import { ca } from '@cian/analytics';

import { createDeveloperProduct } from 'shared/utils/analytics';

/**
 * @description Событие: блок «Проекты ПИК» попал в зону видимости (показ секции).
 */
export function trackShowPikProjectsSection(): void {
  ca('eventSite', {
    action: 'show_landing_section',
    category: 'Promo',
    label: 'pik_projects',
    name: 'oldevent',
    products: [createDeveloperProduct()],
  });
}
